import { connect } from 'react-redux'
import TextSlideCreaeteDialog from './create-dialog.jsx'
import { createSlide } from '../../../../stores/presentation/presentation.actions'
import { getCreateSlideRequest } from '../../../../stores/presentation/presentation.selectors'
import { getCreateSlideDialog } from '../../../pages/lesson/builder/redux/builder.selectors.js'
import { closeCreateSlideDialog } from '../../../pages/lesson/builder/redux/builder.actions.js'

const mapStateToProps = state => {
  const createSlideDialog = getCreateSlideDialog(state)
  const createRequest = getCreateSlideRequest(state)
  return {
    pending: createRequest.pending && createRequest.params.type === 'Text',
    modalOpened: createSlideDialog.opened && createSlideDialog.type === 'Text'
  }
}

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(closeCreateSlideDialog()),
  onSubmit: values => {
    dispatch(
      createSlide({
        type: 'Text',
        title: values.title,
        body: values.text,
        html_body: values.html
      })
    )
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TextSlideCreaeteDialog)
